import React, { useState } from 'react';
import { AuthLayout } from '../components/AuthLayout';
import { forgotPassword } from '../api/forgotPassword';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await forgotPassword({ email });
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot Password"
      subtitle="Enter your email address and we’ll send you a secure link to reset your password."
    >
      {sent ? (
        <div className="text-center space-y-4">
          <p className="text-sm text-gray-600">
            If an account exists for <strong>{email}</strong>, a reset link has been sent.
          </p>
          <p className="text-xs text-gray-500">Please check your inbox and spam folder.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#AC3F1E] text-white uppercase tracking-wide py-3 font-semibold hover:opacity-90 transition disabled:opacity-60"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
